module.exports = __webpack_public_path__ + "img/stock2.b0fa6839.png";